/**
 * 取消尚未完成的 `<img>` 下载。
 * 从 DOM 移除节点通常不会中止已发出的请求；清空 src / srcset 是目前最接近的取消方式。
 */
export function abortHtmlImage(image: HTMLImageElement | null | undefined) {
  if (!image || image.complete) return

  const picture = image.parentElement
  if (picture?.tagName === 'PICTURE') {
    for (const source of picture.querySelectorAll('source')) {
      source.removeAttribute('srcset')
    }
  }

  image.removeAttribute('srcset')
  image.src = ''
  image.removeAttribute('src')
}
